import React, { useEffect } from 'react';
import BoardButton from '../BoardButton';
import '../modals/styles/HowToPlay.css';
import '../modals/styles/EndModal.css';
import './styles/LimitReachedModal.css';
import { markLimitRuleExplained } from '../../helper/limitWarningSession';

// Game only mounts this the first time a player hits the limit in a session (see
// the reachedLimit effect in Game.jsx) - later hits get an inline chip instead, so
// this component itself never needs to branch on "have they seen this before."
const LimitReachedModal = ({ limit, remainingTargets, totalTargets, onTryAgain, onClose }) => {
    const reachedAnyTargets = remainingTargets < totalTargets - 1;

    useEffect(() => {
        markLimitRuleExplained();
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => e.target?.classList?.contains('howto-modal') && onClose?.();
        const handleEscape = (e) => (e.key === 'Escape' || e.key === 'Esc') && onClose?.();

        document.addEventListener('click', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);

    return (
        <div className='howto-modal' role='dialog' aria-modal='true' tabIndex='-1'>
            <div className='howto-modal-content'>
                <button className='end-modal-close' aria-label='Close' onClick={onClose}>×</button>
                <h2 className='howto-modal-title'>Out of Moves</h2>
                <p>You've used all {limit} moves without reaching the final target.</p>
                <p>This board takes exactly {limit} moves to solve — no more, no less.</p>
                {reachedAnyTargets && (
                    <p>
                        {remainingTargets <= 2
                            ? `Only ${remainingTargets} target${remainingTargets === 1 ? '' : 's'} left!`
                            : `You still had ${remainingTargets} more targets to reach.`}
                    </p>
                )}

                <div className='end-modal-nav limit-reached-actions' style={{ marginTop: '1rem' }}>
                    <BoardButton className='start-button' onClick={onTryAgain} label={'Try Again (Clear)'}>Try Again (Clear)</BoardButton>
                    <BoardButton className='limit-reached-close' onClick={onClose} label={'Close'}>Close</BoardButton>
                </div>
            </div>
        </div>
    );
};

export default LimitReachedModal;
